/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForMetricData extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForMetricData.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForMetricData>): ProgressDetailsForMetricData {
        let obj = Object.assign(new ProgressDetailsForMetricData(), model);
        ProgressDetailsForMetricData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForMetricData>): ProgressDetailsForMetricData {
        if (!model) return null;
        return ProgressDetailsForMetricData.newInstance(<ProgressDetailsForMetricData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForMetricData) {
        if (!obj) return;

        models.ProgressDetailsForMetricData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForMetricData): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForMetricData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Run Id
     */
    run_id: string;

}
